var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',_vm._l((_vm.value),function(keyword,index){return _c('li',{key:index,staticClass:"form-control-static text-prewrap",attrs:{"data-testid":"-pvkeyword"}},[_vm._v(_vm._s(keyword || _vm.app_lang.NO_INPUT))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-446818e5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/PvKeywordsView.vue
// module id = null
// module chunks = 